var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.459,
    height: 20.438,
    viewBox: "0 0 20.459 20.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.959 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.038,30.775a5.11,5.11,0,0,1-3.577-1.482,5.007,5.007,0,0,1,0-7.153L9.14,18.462a5.007,5.007,0,0,1,7.153,0,1.022,1.022,0,0,1-1.431,1.431,3.066,3.066,0,0,0-4.292,0L6.892,23.571a3.035,3.035,0,1,0,4.292,4.292l2.3-2.4a1.022,1.022,0,0,1,1.431,1.431l-2.3,2.4A5.11,5.11,0,0,1,9.038,30.775Z",
    transform: "translate(0 -6.337)",
    fill: "#142e38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.281,17.8A5.11,5.11,0,0,1,19.7,16.314a1.022,1.022,0,0,1,1.431-1.431,3.066,3.066,0,0,0,4.292,0L29.106,11.2a3.035,3.035,0,1,0-4.292-4.292l-2.3,2.4a1.022,1.022,0,0,1-1.431-1.431l2.3-2.4a5.058,5.058,0,1,1,7.154,7.154l-3.679,3.679A5.11,5.11,0,0,1,23.281,17.8Z",
    transform: "translate(-7.601)",
    fill: "#142e38"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.8744ce25274627a9436440f0685363f8.svg";
export { ForwardRef as ReactComponent };